import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconQm3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"qm3, room, transform, xyz, 3d"} maskId="square-filled-radius-0-stroke-1-IconQm3"><path fillRule="evenodd" clipRule="evenodd" d="M8.50008 2.79285L13.2072 7.49995L12.5001 8.20706L9.00008 4.70706V15H21.0001V16H8.70718L3.50008 21.2071L2.79297 20.5L8.00008 15.2928V4.70706L4.50008 8.20706L3.79297 7.49995L8.50008 2.79285Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconQm3;
